var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M568.017 201.664C521.554 124.598 419.628 64 375.976 64C375.976 64 346.615 64 288.001 109C229.388 64 200.025 64 200.025 64C156.374 64 54.447 124.598 7.984 201.664C-1.354 217.074 -2.479 235.859 4.495 252.398C29.697 312.25 105.861 448 251.325 448H324.675C470.14 448 546.304 312.25 571.505 252.398C578.48 235.859 577.355 217.074 568.017 201.664ZM288.005 320C138.708 320 64.005 224 64.005 224S120.005 192 204.005 192L234.958 200.875C251.474 205.5 269.63 208 288.005 208S324.536 205.5 341.052 200.875L372.005 192C456.005 192 512.005 224 512.005 224S437.302 320 288.005 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLips);
export default __webpack_public_path__ + "static/media/lips.08315beb4a2e83b541482b805a3c303c.svg";
export { ForwardRef as ReactComponent };